"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../../components/StyledComponents/BaseComponents");
var _services = require("../../services");
var _useRecommendationCosts = require("../.././hooks/recommendation/useRecommendationCosts");
var _useAppSelector = require("../.././hooks/useAppSelector");
var _recommendationSelectors = require("../.././store/recommendation/recommendationSelectors");
var _useCustomer = require("../.././hooks/questionnaire/useCustomer");
var _useQuestionsMetadata = require("../.././hooks/questionnaire/useQuestionsMetadata");
var _useConfig = _interopRequireDefault(require("../.././hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const RecommendationSummary = props => {
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    handset,
    plan,
    totalUpfrontCost,
    totalTermCost,
    totalTermCostAfterDiscount,
    discountPrices,
    handsetUpfrontCost,
    additionalPlans,
    broadband,
    businessSolution,
    connectivityPlan
  } = (0, _useRecommendationCosts.useRecommendationCosts)();
  const numberOfPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const metadata = (0, _useQuestionsMetadata.useQuestionsMetadata)();
  const basicPlanIds = (0, _useConfig.default)('basicPlanIds', []);
  const hidePriceAfterDiscount = (0, _useConfig.default)('hidePriceAfterDiscount', false);
  const minimumDiscount = (0, _useConfig.default)('minimumDiscount', 10);
  const isSmallScreen = breakPoints.sm;
  const showFullPlanName = (0, _useConfig.default)('showFullPlanName', true);
  const planIdWithDifferentHeader = (0, _useConfig.default)('planIdWithDifferentHeader', []);
  const products = [handset, {
    ...plan,
    additional: additionalPlans
  }, broadband, businessSolution, connectivityPlan].filter(product => !!product);
  const handsetTermCost = handset === null || handset === void 0 ? void 0 : handset.termCost;
  const Parser = (0, _react.useMemo)(() => new _services.Services.Parsers.RecommendationSummaryParser({
    totalTermCost,
    totalTermCostAfterDiscount,
    totalUpfrontCost,
    discountPrices,
    numberOfPlans,
    hidePriceAfterDiscount,
    metadata,
    isCustomer,
    basicPlanIds,
    handsetUpfrontCost,
    products,
    minimumDiscount,
    isSmallScreen,
    handsetTermCost,
    plan,
    showFullPlanName,
    planIdWithDifferentHeader
  }), [totalTermCost, totalTermCostAfterDiscount, totalUpfrontCost, discountPrices, numberOfPlans, hidePriceAfterDiscount, metadata, isCustomer, basicPlanIds, handsetUpfrontCost, products, minimumDiscount, isSmallScreen, handsetTermCost, plan, showFullPlanName, planIdWithDifferentHeader]);
  const {
    testId,
    flexDirection
  } = props;
  const {
    hideDiscount,
    priceValue,
    totalNumberOfPlans,
    transformedProducts,
    columns
  } = Parser.RecommendationSummaryValues;
  const flexBasis = (0, _react.useMemo)(() => Parser.getComponentFlexBasis, [columns]);
  const WrapperComponent = Parser === null || Parser === void 0 ? void 0 : Parser.WrapperComponent;
  return /*#__PURE__*/_react.default.createElement(_BaseComponents.BorderWrapper, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.PageWrapper, {
    gap: 16
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    flexDirection: flexDirection,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: breakPoints.sm ? 3 : 1,
    weight: 2,
    dataAttributes: {
      'data-testid': `order-summary-title-${testId}`
    },
    text: _services.Services.locale.localeString('Recommendation.Summary')
  })), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    flexDirection: flexDirection,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null)), !breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    flexDirection: flexDirection,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
    flexBasis: flexBasis
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `products-column-title-${testId}`
    }
  }, _services.Services.locale.localeString('Recommendation.Products'))), !!totalUpfrontCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
    breakPoints: breakPoints
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.Services.locale.localeString('RelationshipOffer.Upfront'), " ")), !!totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
    breakPoints: breakPoints,
    alignItems: "right"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `prices-column-title-${testId}`
    }
  }, _services.Services.locale.localeString('RelationshipOffer.Monthly')))), breakPoints.mdAndAbove && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), transformedProducts.map(product => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: product.variantId
    }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      dataAttributes: {
        'data-test-id': `plan-section-title-${testId}`
      },
      text: _services.Services.locale.localeString(`Recommendation.${product.productType}`)
    })), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: breakPoints.sm ? 3 : 0
      }
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `products-column-title-${testId}`
      }
    }, _services.Services.locale.localeString('Recommendation.Products'), ' '))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `plan-name-${testId}`
      }
    }, product.name))), !!handsetUpfrontCost && product.productType === _constants.PRODUCT_TYPES.HANDSET && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.Services.locale.localeString('RelationshipOffer.Upfront')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, Parser.productUpfrontCost)))), !!totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints,
      alignItems: "right"
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `prices-column-title-${testId}`
      }
    }, _services.Services.locale.localeString('RelationshipOffer.Monthly')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.MainTextWrapper, {
      "data-test-id": `price-after-discount-order-summary-${testId}`,
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      weight: breakPoints.sm ? 3 : 2,
      noMargin: true
    }, product.termCostDisplay), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true,
      size: 1,
      weight: breakPoints.sm ? 3 : 2
    }, "/", _services.Services.locale.localeString('Recommendation.month'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `plan-price-order-summary-${testId}`
      },
      size: 1
    }, product.costSubText)))), product.additional && !(isCustomer && numberOfPlans === 1) && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: breakPoints.sm ? 3 : 0,
        top: breakPoints.sm ? 5 : 0
      }
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': `products-column-title-${testId}`
      }
    }, _services.Services.locale.localeString('Recommendation.Products'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: breakPoints.sm ? 2 : 0
      }
    }, /*#__PURE__*/_react.default.createElement(_BaseComponents.TextAndPillWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': `additional-plan-${testId}`
      },
      noMargin: true
    }, product.additionalPlanText))))), !!totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints,
      alignItems: "right"
    }, breakPoints.sm && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `prices-column-title-${testId}`
      }
    }, _services.Services.locale.localeString('RelationshipOffer.Monthly')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.MainTextWrapper, {
      "data-test-id": `additional-price-after-discount-summary-${testId}`,
      breakPoints: breakPoints
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true,
      weight: breakPoints.sm ? 3 : 2
    }, _services.Services.locale.formatPrice(product.additional.totalCostAfterDiscount)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      noMargin: true,
      size: 1,
      weight: breakPoints.sm ? 3 : 2
    }, "/", _services.Services.locale.localeString('Recommendation.month'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `additional-price-order-summary-${testId}`
      },
      size: 1
    }, !hideDiscount && _services.Services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
      amount: product.additional.termDuration,
      unit: _services.Services.locale.localeString('Recommendation.month'),
      price: _services.Services.locale.formatPrice(product.additional.totalCost),
      pluralUnit: _services.Services.locale.localeString('Recommendation.Month')
    })))));
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    flexDirection: flexDirection,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
    flexBasis: flexBasis,
    padding: {
      bottom: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    noMargin: true,
    dataAttributes: {
      'data-testid': `total-plan-number-${testId}`
    },
    text: totalNumberOfPlans > 1 && !totalUpfrontCost ? _services.Services.locale.localeString('Recommendation.TotalNumOfPlans', {
      amount: totalNumberOfPlans
    }) : _services.Services.locale.localeString('Recommendation.Total'),
    weight: 3
  })), /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
    breakPoints: breakPoints
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!(discountPrices !== null && discountPrices !== void 0 && discountPrices.discountPercentage) && /*#__PURE__*/_react.default.createElement(_BaseComponents.OnlineDiscountPill, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    noMargin: true,
    justify: "center",
    size: 1,
    weight: 2
  }, /*#__PURE__*/_react.default.createElement("span", null, `${Math.round(discountPrices.discountPercentage)}%`), ' ', _services.Services.locale.localeString('Recommendation.onlineDiscount'))), !!priceValue && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    noMargin: true,
    text: _services.Services.locale.formatPrice(priceValue),
    weight: 3
  }))), !!totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.AlignContainer, {
    breakPoints: breakPoints,
    alignItems: "right"
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.MainTextWrapper, {
    "data-test-id": `total-price-after-discount-${testId}`,
    breakPoints: breakPoints
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    noMargin: true,
    text: Parser.totalTermCostText,
    weight: 3
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    noMargin: true,
    text: `/${_services.Services.locale.localeString('Recommendation.month')}`
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `total-price-${testId}`
    },
    size: breakPoints.sm ? 2 : 1
  }, !hideDiscount && totalTermCostAfterDiscount ? _services.Services.locale.localeString('Recommendation.RightStackBottomTextTemplate', {
    amount: plan.termDuration,
    unit: _services.Services.locale.localeString('Recommendation.month'),
    price: _services.Services.locale.formatPrice(totalTermCost),
    pluralUnit: _services.Services.locale.localeString('Recommendation.Month')
  }) : ''), !!numberOfPlans && !(isCustomer && numberOfPlans === 1) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: breakPoints.sm ? 3 : 2,
    noMargin: true,
    dataAttributes: {
      'data-test-id': `price-per-plan-${testId}`
    },
    text: `${_services.Services.locale.formatPrice(totalTermCostAfterDiscount / totalNumberOfPlans)}c/${_services.Services.locale.localeString('Recommendation.plan')}`,
    weight: breakPoints.sm ? 2 : 3
  }))))));
};
var _default = RecommendationSummary;
exports.default = _default;
RecommendationSummary.propTypes = {
  testId: _propTypes.default.string,
  flexDirection: _propTypes.default.string
};